import React from "react";
import {
  Datagrid,
  EditButton,
  List,
  ShowButton,
  TextField,
  SelectField,
  DateField,
  useListController,
} from "react-admin";
import { EmptyList } from "../../../../common/components";
import { subscriptionsFilter } from "../../Partials/Filters";
import { DownloadTopToolbarButton } from "../../../../utils/customActions";
import { SubscriptionsExpand } from "../../Partials/ListExpands/SubscriptionsExpand";
import { dateOptions, paymentStatus, paymentType } from "utils/options";
import { ClearFiltersButton } from "components/features/Partials/CustomComponents/ClearFiltersButton";
import Empty from "utils/Empty";
const ListSubscriptions = props => {
  const { filterValues, page, perPage } = useListController();

  return (
    <List
      {...props}
      actions={
        <DownloadTopToolbarButton
          customResources={"editions/download"}
          fileName={"editions"}
          filterParams={{ filterValues, page, perPage }}
        />
      }
      filters={subscriptionsFilter}
      sx={{ marginTop: "1.5em" }}
    >
      <ClearFiltersButton source={"editions"} />

      <Datagrid
        bulkActionButtons={false}
        empty={<Empty msg={"Няма резултати, които да бъдат експортирани в ексел"} />}
        expand={<SubscriptionsExpand />}
        expandSingle
      >
        <TextField
          label="№"
          source="subscription_id"
          sortable={false}
        />
        <TextField
          label="Име на заявител"
          source="giver_first_name"
          sortable={true}
        />
        <TextField
          label="Фамилия на заявител"
          source="giver_last_name"
          sortable={true}
        />
        <TextField
          label="е - мейл на заявител"
          source="giver_email"
        />
        <TextField
          label="Име на получател"
          source="receiver_first_name"
        />
        <TextField
          label="Фамилия на получател"
          source="receiver_last_name"
          sortable={true}
        />
        <TextField
          label="Нас. място на получател"
          source="receiver_city"
        />
        <TextField
          label="Пощенски код"
          source="receiver_postcode"
        />
        <DateField
          label="Дата на заявка на абонамента"
          sortable={false}
          source="order_date"
          locales={"bg"}
          options={dateOptions}
        />

        <SelectField
          sortable={false}
          label="Метод на плащане"
          source="payment_type"
          choices={paymentType}
        />
        <SelectField
          sortable={false}
          label="Статус на плащане"
          source="payment_status"
          choices={paymentStatus}
        />

        <DateField
          label="Дата на плащане"
          source="purchase_date"
          locales={"bg"}
          options={dateOptions}
        />
        <TextField
          label="Сума"
          source="total_sum"
        />
        <ShowButton label="" />
        <EditButton label="" />
      </Datagrid>
    </List>
  );
};

export default ListSubscriptions;
